import { asHintId, type Hint } from '@/shared/stores';

import { CARE_STATE_NOTE_TAB_ANCHOR } from './anchors';

export const careStateNoteHint: Hint = {
  id: asHintId('patient-workspace:care-state-note'),
  version: 1,
  priority: 95,
  anchor: CARE_STATE_NOTE_TAB_ANCHOR,
  copy: {
    title: 'Notes that follow your scope',
    body: 'This note belongs to whatever you have selected — patient, problem, or request. Switching scope swaps in the right note. Cortex can read and update it for you too.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
